module.exports = __webpack_public_path__ + "img/big-pointer.82b068ca.svg";